import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addGroup,
  getGroups,
  getGroup,
  editGroup,
  deleteGroup,
  getAllGroups,
} from "../../store/actions/group_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllGroups = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.group);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteGroup(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getGroups({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleGroup = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.group);
  useEffect(() => {
    dispatch(getGroup(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateGroup = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.group);
  const addData = async (data) => {
    await dispatch(addGroup(data));
  };
  return [data, addData];
};
export const useUpdateGroup = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.group);
  const updateData = async (id, data) => {
    await dispatch(editGroup(id, data));
  };
  return [updateData];
};

export const useSelectAllGroup = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.group);
  useEffect(() => {
    dispatch(getAllGroups({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

 
  return [dropdownOptions
    // setClientSearchField, setClientSearchValue
  ];
};